import { render, staticRenderFns } from "./preference.vue?vue&type=template&id=61128179&"
import script from "./preference.vue?vue&type=script&lang=js&"
export * from "./preference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports